import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { PageTab } from "./PageTabs";

export type ArchiveTab = "active" | "archived";

export interface UseArchiveFilterResult {
  tab: ArchiveTab;
  setTab: (tab: ArchiveTab) => void;
  isArchivedFilter: boolean;
  tabsFor: (counts: {
    active: number | null;
    archived: number | null;
  }) => PageTab[];
}

export const useArchiveFilter = (): UseArchiveFilterResult => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const tab: ArchiveTab =
    params.get("tab") === "archived" ? "archived" : "active";

  const setTab = useCallback(
    (next: ArchiveTab) => {
      const updated = new URLSearchParams(location.search);
      if (next === "active") {
        updated.delete("tab");
      } else {
        updated.set("tab", "archived");
      }
      const qs = updated.toString();
      navigate(
        { pathname: location.pathname, search: qs ? `?${qs}` : "" },
        { replace: true }
      );
    },
    [location.pathname, location.search, navigate]
  );

  const tabsFor = useCallback(
    (counts: { active: number | null; archived: number | null }): PageTab[] => [
      { key: "active", label: "Active", count: counts.active },
      { key: "archived", label: "Archived", count: counts.archived },
    ],
    []
  );

  return { tab, setTab, isArchivedFilter: tab === "archived", tabsFor };
};
